export default __webpack_public_path__ + "static/1357-9fc021e79745ca51638874e84c432512.gif";